import store from '@/store'
import { API_BASE, apiErrorHandler } from '../api'
import { objectToSnakeCase } from '../utils'
import Auth from '../auth'

const EXPENSE_CATEGORY_ENDPOINT = `${API_BASE}expense-categories/`

export default class ExpenseCategoryAPI {
  constructor(cls) {
    this.cls = cls
  }
  static create(cls) {
    return new ExpenseCategoryAPI(cls)
  }

  list() {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = store.state.axiosApi.get(EXPENSE_CATEGORY_ENDPOINT, options)
    return promise
      .then(res => ({ ...res.data, results: res.data.results.map(this.cls.fromAPI) }))
      .catch(apiErrorHandler({ apiName: 'List Expense Category API Error' }))
  }
}
